import { message } from 'antd';
import { ROLE_STUDENT } from 'constants/types';
import { dispatcher, api } from '@unicus/react-ui-kit';

export const ACCOUNT = 'ACCOUNT';
export const ACCOUNT_SHARING_UNLOAD = 'ACCOUNT_SHARING_UNLOAD';
export const ACCOUNT_SHARING_GET = 'ACCOUNT_SHARING_GET';
export const ACCOUNT_SHARING_GET_FINISHED = 'ACCOUNT_SHARING_GET_FINISHED';
export const ACCOUNT_SHARING_GET_ERROR = 'ACCOUNT_SHARING_GET_ERROR';
export const ACCOUNT_ACTIVITY_FETCH = 'ACCOUNT_ACTIVITY_FETCH';
export const ACCOUNT_ACTIVITY_FETCH_FINISHED =
  'ACCOUNT_ACTIVITY_FETCH_FINISHED';
export const ACCOUNT_SETTINGS_GET = 'ACCOUNT_SETTINGS_GET';
export const ACCOUNT_SETTINGS_GET_FINISHED = 'ACCOUNT_SETTINGS_GET_FINISHED';
export const ACCOUNT_SETTINGS_UPDATE = 'ACCOUNT_SETTINGS_UPDATE';
export const ACCOUNT_SETTINGS_UPDATE_FINISHED =
  'ACCOUNT_SETTINGS_UPDATE_FINISHED';

export const ACCOUNT_CANCEL = 'ACCOUNT_CANCEL';
export const ACCOUNT_CANCEL_FINISHED = 'ACCOUNT_CANCEL_FINISHED';

const getResourceByRole = (role) => {
  switch (role) {
    case ROLE_STUDENT:
      return 'student-accounts';
    default:
      return 'professional-accounts';
  }
};

export const getErrorSharing = (payload) => (dispatch) => {
  dispatch(
    dispatcher.createAction(ACCOUNT_SHARING_GET_ERROR, 'accounts', payload)
  );
};

export const getSharing = (token) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'accounts',
    actionType: ACCOUNT_SHARING_GET,
    effect: async () => api.get('activities/share-by-token', token),
    onFail: (response) => {
      dispatch(getErrorSharing(response));
      return true;
    }
  });
};

export const fetchActivities = (token, queryParams) => async (dispatch) => {
  queryParams.shareToken = token;
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'accounts',
    actionType: ACCOUNT_ACTIVITY_FETCH,
    effect: async () => api.fetch('activities', queryParams)
  });
};

export const unloadSharing = () => (dispatch) => {
  dispatch(dispatcher.createAction(ACCOUNT_SHARING_UNLOAD, 'accounts'));
};

export const getSettings = (role, onSuccess) => async (dispatch) => {
  const resource = getResourceByRole(role);
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'accounts',
    actionType: ACCOUNT_SETTINGS_GET,
    effect: async () => api.get(resource, 'settings'),
    onSuccess
  });
};

export const updateSettings = (role, data, onSuccess) => async (dispatch) => {
  const resource = getResourceByRole(role);

  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'accounts',
    actionType: ACCOUNT_SETTINGS_UPDATE,
    effect: async () => api.put(`${resource}/settings`, data),
    payload: data,
    onSuccess: (response) => {
      if (onSuccess) {
        onSuccess(response);
      }

      message.success('Configurações salvas com sucesso.');
    }
  });
};

export const cancel = (resource, id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource,
    actionType: ACCOUNT_CANCEL,
    effect: async () => api.del(resource, id),
    onSuccess
  });
};
